export default (lang: string) => {
    return useFetch(`/api/countries?lang=${lang}`)
}
